module.exports = "/assets/js/5250e012b0ab5c55e3b7cd5ac990a9c9.svg";